import Vue from 'vue';

//Customer API Client
export const CustomerAPIClient = {
  getCustomerIds: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/getCustomerIds', customerIds).then(function (data) {
        if(data.data.Data){
        resolve(data.data.Data)          
        }
        else
        {
          reject()
        }
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerHeader: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerHeader', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerContact: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerContact', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerProfile: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerProfile', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerDemographics: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerDemographics', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerInterest: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerInterests', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerSearches: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerSearches', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerVOIs: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/customervois', customerIds).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerReviews: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerReviews', customerIds).then(function (data) {
        if(data.data.Data && data.data.Data.ReviewList) resolve(data.data.Data.ReviewList)
        else resolve([])
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerEngagement: function (customerIds) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/CustomerEngagement', customerIds).then(function (data) {
        if(data.data.Data && data.data.Data.SignalList)
        resolve(data.data.Data.SignalList)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getHighIntensityActiveLeadsReport: function (platformId) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/HighIntensityActiveLeadsReport', platformId).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getActiveLeadsLosingIntensityReport: function (platformId) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/ActiveLeadsLosingIntensityReport', JSON.stringify(platformId)).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getLostLeadsInMarketReport: function (platformId) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/LostLeadsInMarketReport', JSON.stringify(platformId)).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getSoldCustomersBackInMarketReport: function (platformId) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/SoldCustomersBackInMarketReport', JSON.stringify(platformId)).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getRecentlyViewedReport: function (platformId) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/profilefuze/RecentlyViewedReport',JSON.stringify(platformId)).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  postPatternSearch: function (searchTerm) {
    return new Promise((resolve, reject) => {
      let body = {}
      body.SearchQuery = searchTerm
      Vue.http.post('/profilefuze/CustomerSearchReport', body).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  getCustomerGroups: function (custIds) {
    let params = custIds
    params.AACustomerId = custIds.AutoAlertCustomerID;
    let queryString = Object.keys(params).map(function (key) {
      if (params[key] != null)
        return key + '=' + params[key]
      else
        return key + '='
    }).join('&');
    return new Promise((resolve, reject) => {
      Vue.http.get('/groups?' + queryString).then(function (data) {
        resolve(data.data.Data)
      }).catch(function (error) {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/data_access/Customer.js